/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseWorkspaceRole } from './BaseWorkspaceRole';
import type { WorkspaceDomain } from './WorkspaceDomain';
import type { WorkspaceOption } from './WorkspaceOption';
import type { WorkspaceStatus } from './WorkspaceStatus';

export type Workspace = {
  name: string;
  slug: string;
  status: WorkspaceStatus;
  created_at: string;
  updated_at: string;
  base_role?: BaseWorkspaceRole | null;
  default_access_scope: Workspace.default_access_scope;
  default_transcribe_language: Workspace.default_transcribe_language;
  keywords: Array<string>;
  color: string;
  email?: string | null;
  billing_email: string;
  record_lifecycle_days?: number | null;
  use_2fa: boolean;
  ip_block_type: Workspace.ip_block_type;
  option: WorkspaceOption;
  domains: Array<WorkspaceDomain>;
  readonly extended_languages: boolean;
  readonly sc: Workspace.sc;
};

export namespace Workspace {
  export enum default_access_scope {
    ALL = 'all',
    TEAM = 'team',
    ATTENDEES = 'attendees',
  }

  export enum default_transcribe_language {
    DETECT = 'detect',
    MULTI = 'multi',
    KO = 'ko',
    EN = 'en',
    JA = 'ja',
    ZH = 'zh',
    ES = 'es',
    FR = 'fr',
    DE = 'de',
    RU = 'ru',
    PT = 'pt',
    IT = 'it',
    AR = 'ar',
    HI = 'hi',
    ID = 'id',
    VI = 'vi',
    TH = 'th',
    NL = 'nl',
  }

  export enum ip_block_type {
    NONE = 'none',
    ALLOW_LIST = 'allow_list',
  }

  export enum sc {
    P = 'p',
    S = 's',
    I = 'i',
    E = 'e',
  }
}
